export enum SaleType {
  APP = 'app',
  GO = 'go',
  POS = 'pos',
  SELF_SERVICE = 'self_service',
}
